import * as React from 'react';
import './abilitydisplay.css';
import {AbilityInfo} from "../../fbobjects/calculation/AbilityInfo";
import DamageInfo from "../../fbobjects/calculation/DamageInfo";

interface AbilityDisplayCProps{
    ability: AbilityInfo;
    icon?:string;
    hasImage:boolean;
    damageInfo:DamageInfo;
    onClick?:(string:string, isOn:boolean)=>void;
    isDamageModifier?:boolean;
}


export default class AbilityDisplayC extends React.Component<AbilityDisplayCProps,any> {

    props:AbilityDisplayCProps;

    constructor(props:AbilityDisplayCProps){
        super(props);
        this.props = props;
        this.state = {
            isHovered:false,
            isOn:false,
        }
    }

    renderAbilityImage(){
        if (this.props.hasImage){
            return <img className={this.getDamageModifierColor()} src={this.props.icon} />
        }
        return <div className="combo-ability-auto" />
    }

    handleMouseEnter(){
        this.setState({isHovered:true});

    }

    handleMouseLeave(){
        this.setState({isHovered:false});

    }

    renderRank(key){
        if ('QWER'.indexOf(key) != -1){
            return <div className="tooltip-rank">RANK {this.props.damageInfo.rank}</div>
        }
        return <div></div>
    }

    handleOnAbilityClick(){
        if (this.props.onClick != undefined){
            this.state.isOn = !this.state.isOn;
            this.props.onClick(this.props.ability.name,this.state.isOn);
            this.setState({isOn:this.state.isOn})
        }

    }

    getDamageModifierColor(){
        if (this.props.isDamageModifier != undefined){
            if (this.state.isOn == false && this.props.isDamageModifier == true) {
                return "combo-ability-image-gray";
            }
        }
        return "combo-ability-image-color"
    }

    renderCursorByAbility(isDamageModifier){
        if (isDamageModifier != undefined){
                return "damage-modifier-container"
        }
        return "ability-container"
    }

    renderTooltip(){
        let ability = this.props.ability;
        let tooltip = ability.tooltip;
        if (this.state.isHovered == true){
            return(
                <div className="ability-tooltip">
                    <div className="ability-name">{ability.name}</div>
                        {this.renderRank(ability.key)}
                    <hr/>
                    <div className="tooltip-description">{tooltip}</div>
                    <br/>
                    <div className="tooltip-numbers">
                        <div className="damage-title">Damage Dealt After Resistances:</div>

                        <div className="damage-types">
                            <div className="physical">{this.props.damageInfo.adDamage.toFixed(1)}</div> <div>Physical</div>
                        </div>
                        <div className="damage-types">
                            <span className="magic">{this.props.damageInfo.apDamage.toFixed(1)}</span> Magic
                        </div>
                        <div className="damage-types">
                            <span className="true">{this.props.damageInfo.trueDamage.toFixed(1)}</span> True
                        </div>
                    </div>
                </div>
            );
        }
        return <div></div>;
    }

    render(){
        return(
            <div className="combo-ability-outer-container">
                <div className={this.renderCursorByAbility(this.props.isDamageModifier)}
                     onMouseEnter={()=>this.handleMouseEnter()}
                     onMouseLeave={()=>this.handleMouseLeave()}
                     onClick={()=>this.handleOnAbilityClick()}
                >
                    {this.renderAbilityImage()}
                    <div className="combo-ability-text" >
                        {this.props.isDamageModifier ? null : this.props.ability.key}
                    </div>
                </div>
                {this.renderTooltip()}
            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/AbilityDisplayC/index.tsx